const $linksDownload = $('[data-download]');

const checkEmpty = function() {
    let retorno = true, campos = [], name;
    $('#formcontato input, #formcontato textarea, #formcontato select').each((i, e) => {
        if(!$(e).val() || $(e).val().trim() == '') {
            console.log($(e))
            name = $(e).attr('placeholder');
            retorno = false;
            if(name) {
                campos.push(name.replace(':', ''));
            }
        }
    })
    if(!retorno) {
        Swal("Ops", "Preencha o(s) campo(s) "+campos.join(', ').toLowerCase(), "warning");
        grecaptcha.reset();
        return false;
    } else {
        return true;
    }
}

const contatoEnviar = (function(secretKey) {
    return new Promise(function(resolve, reject) {
        let
        comando = 'contato',
        action = 'sendform',
        form = $('#formcontato').serialize(),
        obj = {
            url: scriptParams.ajaxurl,
            data: {form, action, comando},
            dataType: 'JSON',
            method: 'POST',
            beforeSend: () => {
                Swal("Enviando");
                Swal.showLoading();
            }
        };

        if(!checkEmpty()) {
            return false;
        }

        $.ajax(obj)
        .done(data=> {
            if(data) {
                Swal("Ok", "Mensagem enviada com sucesso, aguarde nosso retorno, obrigado!", "success");
            } else {
                Swal("Ops", "Algo deu errado, tente contato por telefone, obrigado!", "warning");
            }
        })
        .fail(data=> {
            Swal("Ops", "Algo deu errado, tente contato por telefone, obrigado!", "warning");
        })
        .always(data=> {
            $('#formcontato input, #formcontato textarea').val('');
            grecaptcha.reset();
        })
    })
})

$linksDownload.click(function(e) {
    e.preventDefault();

    var self = $(this);
    $('body').attr('data-ajax', scriptParams.ajaxurl);
    Swal.mixin({
        input: 'text',
        confirmButtonText: 'Próximo &rarr;',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        progressSteps: ['1', '2']
      }).queue([
        {
            title: 'Antes do download...',
            inputPlaceholder: 'Digite aqui seu nome completo',
            inputValidator: (value) => {
                return !value && 'Campo obrigatório!'
            }
        },
        {
            title: 'Agora seu e-mail',
            inputPlaceholder: 'Digite aqui seu melhor e-mail',
            input: 'email',
            validationMessage: "Entre com um formato de e-mail válido!"
        }
      ]).then((result) => {
        if (result.value) {

            let
            comando = 'registro',
            action = 'sendform',
            produto = self.attr('data-download'),
            form = result.value;
 
            var obj = {
                url: $('body').attr('data-ajax'),
                data: {form, action, comando, produto},
                dataType: 'JSON',
                method: 'POST',
                beforeSend: () => {
                    Swal("Preparando download...");
                    Swal.showLoading();
                }
            };

            $.ajax(obj)
            .done(data=> {
                if(data) {
                    Swal("Ok", "Tudo certo, seu download sera iniciado, clique em ok para finalizar", "success");
                    $('.link-download').attr('href', self.attr('href')).get(0).click();
                } else {
                    Swal("Ops", "Algo deu errado, tente contato pelo número +55 11 4581-8323, obrigado!", "warning");
                }
            })
            .fail(data=> {
                Swal("Ops", "Algo deu errado, tente contato pelo número +55 11 4581-8323, obrigado!", "warning");
            })
        
        }
    });
})